<template>
  <div class="qrcode-download">
    <div class="content">
      <div class="header">
        <div class="title">下载二维码</div>
        <div class="headerbtn" @click="closeBox">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <div class="body">
        <el-table :data="tableData" style="width: 300px;">
          <el-table-column prop="scene" label="适用场景" width="100"> </el-table-column>
          <el-table-column prop="size" label="尺寸" width="100"> </el-table-column>
          <el-table-column prop="handle" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row.name)" type="text" class="handlebtn">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <vue-qr class="qr-content-img" :text="qrObj.value" :size="1280" ref="qrCodeLarge" :margin="5" v-show="false" />
    <vue-qr class="qr-content-img" :text="qrObj.value" :size="640" ref="qrCodeMedium" :margin="5" v-show="false" />
    <vue-qr class="qr-content-img" :text="qrObj.value" :size="120" ref="qrCodeSmall" :margin="5" v-show="false" />
  </div>
</template>

<script>
import VueQr from 'vue-qr'
export default {
  name: 'qrcodedownload',
  data() {
    return {
      tableData: [
        {
          scene: '3.0m内扫码',
          size: '1280*1280',
          name: 1280
        },
        {
          scene: '1.5m内扫码',
          size: '640*640',
          name: 640
        },
        {
          scene: '0.5m内扫码',
          size: '120*120',
          name: 120
        }
      ]
    }
  },
  props: ['qrObj'],
  methods: {
    handleClick(payload) {
      let src = ''
      let size = ''
      switch (payload) {
        case 1280:
          src = this.$refs.qrCodeLarge.$el.currentSrc
          size = '(L)'
          break
        case 640:
          src = this.$refs.qrCodeMedium.$el.currentSrc
          size = '(M)'
          break
        case 120:
          src = this.$refs.qrCodeSmall.$el.currentSrc
          size = '(S)'
          break
      }
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.href = src
      console.log(this.bookObj)
      let title = this.qrObj.title.replace(/[.\\/]+/, '')
      a.download = title + '' + size
      a.click()
      a.style.display = 'none'
      document.body.removeChild(a)
    },
    closeBox() {
      this.$emit('closeDownload')
    }
  },
  components: { VueQr },
  mounted() {
    // to make the download popover above the share popover
    document.body.appendChild(this.$el)
  },
  destroyed() {
    //remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style lang="scss">
.qrcode-download {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20010;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    width: 450px;
    height: 300px;
    background: #fff;
    .header {
      background: #f4f4f4;
      color: #000000;
      padding: 0;
      height: 30px;
      position: relative;
      .title {
        font-size: 14px;
        line-height: 30px;
        text-align: center;
        color: #000;
      }
      .headerbtn {
        position: absolute;
        right: 8px;
        top: 8px;
        width: 14px;
        height: 14px;
        cursor: pointer;
        i {
          width: 100%;
          color: #909399;
          line-height: 14px;
          vertical-align: top;
        }
        i:hover {
          color: #df5813;
        }
      }
    }
    .body {
      display: flex;
      align-items: center;
      height: 270px;
      padding: 0 75px;
      .el-table {
        .el-table__row {
          height: 40px;
        }
      }
      .el-table__row > td {
        /* 去除表格线 */
        border: none;
        padding: 0;
        text-align: center;
        color: #000;
      }
      .el-table th.is-leaf {
        /* 去除上边框 */
        border: none;
        height: 40px;
        text-align: center;
        color: #000;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      .el-table::before {
        /* 去除下边框 */
        height: 0;
      }
      .handlebtn {
        width: 60px;
        height: 26px;
        line-height: 26px;
        background: #ffffff;
        border: 1px solid #df5813;
        padding: 0;
      }
    }
  }
  .qr-content-img {
    display: none !important;
  }
}
</style>
